export default "__VITE_ASSET__D$oBB5Ej__"